module.exports = __webpack_public_path__ + "img/correos.c4adc2aa.png";